import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_PROCON } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { CadastraAtendimentoPjRequest, Types } from './types';

// ACTIONS
import {
	cadastraAtendimentoPjSuccess,
	cadastraAtendimentoPjFailure,
} from './actions';

function* cadastraAtendimentoPjRequest(request: ReducerAction) {
	const { payload }: { payload: CadastraAtendimentoPjRequest } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_PROCON,
		`atendimentos-cip/${CHANNEL}/consumidores-pj/cip`,
		payload,
	);

	if (response.status === 200 || response.status === 201) {
		yield put(cadastraAtendimentoPjSuccess(response));
	} else {
		yield put(cadastraAtendimentoPjFailure(response));
	}
}

export default all([
	takeLatest(
		Types.CADASTRA_ATENDIMENTO_PJ_REQUEST,
		cadastraAtendimentoPjRequest,
	),
]);
